var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPesquisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 254,
    viewBox: "0 0 195 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6750_16050)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6,
    width: 179,
    height: 238,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2051 27.0469V37H64.1543V27.0469H66.2051ZM70.1699 31.2988V32.8984H65.6445V31.2988H70.1699ZM70.6484 27.0469V28.6533H65.6445V27.0469H70.6484ZM71.25 33.377V33.2334C71.25 32.6911 71.3275 32.1921 71.4824 31.7363C71.6374 31.276 71.863 30.8773 72.1592 30.54C72.4554 30.2028 72.82 29.9408 73.2529 29.7539C73.6859 29.5625 74.1826 29.4668 74.7432 29.4668C75.3037 29.4668 75.8027 29.5625 76.2402 29.7539C76.6777 29.9408 77.0446 30.2028 77.3408 30.54C77.6416 30.8773 77.8695 31.276 78.0244 31.7363C78.1794 32.1921 78.2568 32.6911 78.2568 33.2334V33.377C78.2568 33.9147 78.1794 34.4137 78.0244 34.874C77.8695 35.3298 77.6416 35.7285 77.3408 36.0703C77.0446 36.4076 76.68 36.6696 76.2471 36.8564C75.8141 37.0433 75.3174 37.1367 74.7568 37.1367C74.1963 37.1367 73.6973 37.0433 73.2598 36.8564C72.8268 36.6696 72.46 36.4076 72.1592 36.0703C71.863 35.7285 71.6374 35.3298 71.4824 34.874C71.3275 34.4137 71.25 33.9147 71.25 33.377ZM73.2188 33.2334V33.377C73.2188 33.6868 73.2461 33.9762 73.3008 34.2451C73.3555 34.514 73.4421 34.751 73.5605 34.9561C73.6836 35.1566 73.8431 35.3138 74.0391 35.4277C74.235 35.5417 74.4743 35.5986 74.7568 35.5986C75.0303 35.5986 75.265 35.5417 75.4609 35.4277C75.6569 35.3138 75.8141 35.1566 75.9326 34.9561C76.0511 34.751 76.1377 34.514 76.1924 34.2451C76.2516 33.9762 76.2812 33.6868 76.2812 33.377V33.2334C76.2812 32.9326 76.2516 32.6501 76.1924 32.3857C76.1377 32.1169 76.0488 31.8799 75.9258 31.6748C75.8073 31.4652 75.6501 31.3011 75.4541 31.1826C75.2581 31.0641 75.0212 31.0049 74.7432 31.0049C74.4652 31.0049 74.2282 31.0641 74.0322 31.1826C73.8408 31.3011 73.6836 31.4652 73.5605 31.6748C73.4421 31.8799 73.3555 32.1169 73.3008 32.3857C73.2461 32.6501 73.2188 32.9326 73.2188 33.2334ZM81.4355 31.2168V37H79.4668V29.6035H81.3193L81.4355 31.2168ZM83.6641 29.5557L83.6299 31.3809C83.5342 31.3672 83.418 31.3558 83.2812 31.3467C83.1491 31.333 83.0283 31.3262 82.9189 31.3262C82.641 31.3262 82.3994 31.3626 82.1943 31.4355C81.9938 31.5039 81.8252 31.6064 81.6885 31.7432C81.5563 31.8799 81.4561 32.0462 81.3877 32.2422C81.3239 32.4382 81.2874 32.6615 81.2783 32.9121L80.8818 32.7891C80.8818 32.3105 80.9297 31.8708 81.0254 31.4697C81.1211 31.0641 81.2601 30.7109 81.4424 30.4102C81.6292 30.1094 81.8571 29.877 82.126 29.7129C82.3949 29.5488 82.7025 29.4668 83.0488 29.4668C83.1582 29.4668 83.2699 29.4759 83.3838 29.4941C83.4977 29.5078 83.5911 29.5283 83.6641 29.5557ZM86.5625 31.1348V37H84.5869V29.6035H86.4395L86.5625 31.1348ZM86.2891 33.042H85.7422C85.7422 32.527 85.8037 32.0531 85.9268 31.6201C86.0544 31.1826 86.2389 30.8044 86.4805 30.4854C86.7266 30.1618 87.0296 29.9111 87.3896 29.7334C87.7497 29.5557 88.1667 29.4668 88.6406 29.4668C88.9688 29.4668 89.2695 29.5169 89.543 29.6172C89.8164 29.7129 90.0511 29.8656 90.2471 30.0752C90.4476 30.2803 90.6025 30.5492 90.7119 30.8818C90.8213 31.21 90.876 31.6042 90.876 32.0645V37H88.9072V32.2832C88.9072 31.946 88.8617 31.6862 88.7705 31.5039C88.6794 31.3216 88.5495 31.194 88.3809 31.1211C88.2168 31.0482 88.0186 31.0117 87.7861 31.0117C87.5309 31.0117 87.3076 31.0641 87.1162 31.1689C86.9294 31.2738 86.7744 31.4196 86.6514 31.6064C86.5283 31.7887 86.4372 32.0029 86.3779 32.249C86.3187 32.4951 86.2891 32.7594 86.2891 33.042ZM90.6914 32.8164L89.9873 32.9053C89.9873 32.4222 90.0465 31.9733 90.165 31.5586C90.2881 31.1439 90.4681 30.7793 90.7051 30.4648C90.9466 30.1504 91.2451 29.9066 91.6006 29.7334C91.9561 29.5557 92.3662 29.4668 92.8311 29.4668C93.1865 29.4668 93.5101 29.5192 93.8018 29.624C94.0934 29.7243 94.3418 29.8861 94.5469 30.1094C94.7565 30.3281 94.916 30.6152 95.0254 30.9707C95.1393 31.3262 95.1963 31.7614 95.1963 32.2764V37H93.2207V32.2764C93.2207 31.9346 93.1751 31.6748 93.084 31.4971C92.9974 31.3148 92.8698 31.1895 92.7012 31.1211C92.5371 31.0482 92.3411 31.0117 92.1133 31.0117C91.8763 31.0117 91.6689 31.0596 91.4912 31.1553C91.3135 31.2464 91.1654 31.374 91.0469 31.5381C90.9284 31.7021 90.8395 31.8936 90.7803 32.1123C90.721 32.3265 90.6914 32.5612 90.6914 32.8164ZM101.096 35.2295V29.6035H103.064V37H101.212L101.096 35.2295ZM101.314 33.7119L101.896 33.6982C101.896 34.1904 101.839 34.6484 101.725 35.0723C101.611 35.4915 101.44 35.8561 101.212 36.166C100.984 36.4714 100.697 36.7106 100.351 36.8838C100.004 37.0524 99.5964 37.1367 99.127 37.1367C98.7669 37.1367 98.4342 37.0866 98.1289 36.9863C97.8281 36.8815 97.5684 36.7197 97.3496 36.501C97.1354 36.2777 96.9668 35.9928 96.8438 35.6465C96.7253 35.2956 96.666 34.874 96.666 34.3818V29.6035H98.6348V34.3955C98.6348 34.6143 98.6598 34.7988 98.71 34.9492C98.7646 35.0996 98.8398 35.2227 98.9355 35.3184C99.0312 35.4141 99.1429 35.4824 99.2705 35.5234C99.4027 35.5645 99.5485 35.585 99.708 35.585C100.114 35.585 100.433 35.5029 100.665 35.3389C100.902 35.1748 101.068 34.9515 101.164 34.6689C101.264 34.3818 101.314 34.0628 101.314 33.7119ZM106.646 26.5V37H104.671V26.5H106.646ZM112.266 35.332V32.0371C112.266 31.8001 112.227 31.5973 112.149 31.4287C112.072 31.2555 111.951 31.1211 111.787 31.0254C111.628 30.9297 111.42 30.8818 111.165 30.8818C110.946 30.8818 110.757 30.9206 110.598 30.998C110.438 31.071 110.315 31.1781 110.229 31.3193C110.142 31.4561 110.099 31.6178 110.099 31.8047H108.13C108.13 31.4902 108.203 31.1917 108.349 30.9092C108.494 30.6266 108.706 30.3783 108.984 30.1641C109.262 29.9453 109.593 29.7744 109.976 29.6514C110.363 29.5283 110.796 29.4668 111.274 29.4668C111.849 29.4668 112.359 29.5625 112.806 29.7539C113.252 29.9453 113.603 30.2324 113.858 30.6152C114.118 30.998 114.248 31.4766 114.248 32.0508V35.2158C114.248 35.6214 114.273 35.9541 114.323 36.2139C114.373 36.4691 114.446 36.6924 114.542 36.8838V37H112.553C112.457 36.7995 112.384 36.5488 112.334 36.248C112.288 35.9427 112.266 35.6374 112.266 35.332ZM112.525 32.4951L112.539 33.6094H111.438C111.179 33.6094 110.953 33.639 110.762 33.6982C110.57 33.7575 110.413 33.8418 110.29 33.9512C110.167 34.056 110.076 34.179 110.017 34.3203C109.962 34.4616 109.935 34.6165 109.935 34.7852C109.935 34.9538 109.973 35.1064 110.051 35.2432C110.128 35.3753 110.24 35.4801 110.386 35.5576C110.532 35.6305 110.702 35.667 110.898 35.667C111.195 35.667 111.452 35.6077 111.671 35.4893C111.89 35.3708 112.058 35.2249 112.177 35.0518C112.3 34.8786 112.364 34.7145 112.368 34.5596L112.888 35.3936C112.815 35.5804 112.715 35.7741 112.587 35.9746C112.464 36.1751 112.307 36.3643 112.115 36.542C111.924 36.7152 111.694 36.8587 111.425 36.9727C111.156 37.082 110.837 37.1367 110.468 37.1367C109.998 37.1367 109.572 37.0433 109.189 36.8564C108.811 36.665 108.51 36.403 108.287 36.0703C108.068 35.7331 107.959 35.3503 107.959 34.9219C107.959 34.5345 108.032 34.1904 108.178 33.8896C108.324 33.5889 108.538 33.3359 108.82 33.1309C109.107 32.9212 109.465 32.764 109.894 32.6592C110.322 32.5498 110.819 32.4951 111.384 32.4951H112.525ZM110.331 28.6055L111.671 26.5H113.811L111.931 28.6055H110.331ZM117.734 31.2168V37H115.766V29.6035H117.618L117.734 31.2168ZM119.963 29.5557L119.929 31.3809C119.833 31.3672 119.717 31.3558 119.58 31.3467C119.448 31.333 119.327 31.3262 119.218 31.3262C118.94 31.3262 118.698 31.3626 118.493 31.4355C118.293 31.5039 118.124 31.6064 117.987 31.7432C117.855 31.8799 117.755 32.0462 117.687 32.2422C117.623 32.4382 117.586 32.6615 117.577 32.9121L117.181 32.7891C117.181 32.3105 117.229 31.8708 117.324 31.4697C117.42 31.0641 117.559 30.7109 117.741 30.4102C117.928 30.1094 118.156 29.877 118.425 29.7129C118.694 29.5488 119.001 29.4668 119.348 29.4668C119.457 29.4668 119.569 29.4759 119.683 29.4941C119.797 29.5078 119.89 29.5283 119.963 29.5557ZM122.971 29.6035V37H120.995V29.6035H122.971ZM120.872 27.6758C120.872 27.3887 120.972 27.1517 121.173 26.9648C121.373 26.778 121.642 26.6846 121.979 26.6846C122.312 26.6846 122.579 26.778 122.779 26.9648C122.984 27.1517 123.087 27.3887 123.087 27.6758C123.087 27.9629 122.984 28.1999 122.779 28.3867C122.579 28.5736 122.312 28.667 121.979 28.667C121.642 28.667 121.373 28.5736 121.173 28.3867C120.972 28.1999 120.872 27.9629 120.872 27.6758ZM124.283 33.377V33.2334C124.283 32.6911 124.361 32.1921 124.516 31.7363C124.671 31.276 124.896 30.8773 125.192 30.54C125.489 30.2028 125.853 29.9408 126.286 29.7539C126.719 29.5625 127.216 29.4668 127.776 29.4668C128.337 29.4668 128.836 29.5625 129.273 29.7539C129.711 29.9408 130.078 30.2028 130.374 30.54C130.675 30.8773 130.903 31.276 131.058 31.7363C131.213 32.1921 131.29 32.6911 131.29 33.2334V33.377C131.29 33.9147 131.213 34.4137 131.058 34.874C130.903 35.3298 130.675 35.7285 130.374 36.0703C130.078 36.4076 129.713 36.6696 129.28 36.8564C128.847 37.0433 128.351 37.1367 127.79 37.1367C127.229 37.1367 126.73 37.0433 126.293 36.8564C125.86 36.6696 125.493 36.4076 125.192 36.0703C124.896 35.7285 124.671 35.3298 124.516 34.874C124.361 34.4137 124.283 33.9147 124.283 33.377ZM126.252 33.2334V33.377C126.252 33.6868 126.279 33.9762 126.334 34.2451C126.389 34.514 126.475 34.751 126.594 34.9561C126.717 35.1566 126.876 35.3138 127.072 35.4277C127.268 35.5417 127.507 35.5986 127.79 35.5986C128.063 35.5986 128.298 35.5417 128.494 35.4277C128.69 35.3138 128.847 35.1566 128.966 34.9561C129.084 34.751 129.171 34.514 129.226 34.2451C129.285 33.9762 129.314 33.6868 129.314 33.377V33.2334C129.314 32.9326 129.285 32.6501 129.226 32.3857C129.171 32.1169 129.082 31.8799 128.959 31.6748C128.84 31.4652 128.683 31.3011 128.487 31.1826C128.291 31.0641 128.054 31.0049 127.776 31.0049C127.498 31.0049 127.261 31.0641 127.065 31.1826C126.874 31.3011 126.717 31.4652 126.594 31.6748C126.475 31.8799 126.389 32.1169 126.334 32.3857C126.279 32.6501 126.252 32.9326 126.252 33.2334Z",
    fill: "#14223D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 70,
    width: 28,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 71,
    r: 1.5,
    stroke: "#203864"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 75,
    width: 41,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 76,
    r: 1.5,
    stroke: "#203864"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 80,
    width: 56,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 81,
    r: 1.5,
    stroke: "#203864"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 85,
    width: 54,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 86,
    r: 1.5,
    stroke: "#203864"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 90,
    width: 31,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 91,
    r: 1.5,
    stroke: "#203864"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 95,
    width: 46,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 96,
    r: 1.5,
    stroke: "#203864"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 54,
    width: 142,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 58,
    width: 142,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 62,
    width: 52,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3379 54.1504V57H22.7754V54.7988L22.0996 55.0137V54.5703L23.2773 54.1504H23.3379ZM24.3145 56.7285C24.3145 56.6452 24.3431 56.5755 24.4004 56.5195C24.459 56.4635 24.5365 56.4355 24.6328 56.4355C24.7292 56.4355 24.806 56.4635 24.8633 56.5195C24.9219 56.5755 24.9512 56.6452 24.9512 56.7285C24.9512 56.8118 24.9219 56.8815 24.8633 56.9375C24.806 56.9935 24.7292 57.0215 24.6328 57.0215C24.5365 57.0215 24.459 56.9935 24.4004 56.9375C24.3431 56.8815 24.3145 56.8118 24.3145 56.7285Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 162,
    width: 28,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 163,
    r: 1.5,
    stroke: "#203864"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 167,
    width: 41,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 168,
    r: 1.5,
    stroke: "#203864"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 172,
    width: 56,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 173,
    r: 1.5,
    stroke: "#203864"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 177,
    width: 54,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 178,
    r: 1.5,
    stroke: "#203864"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 182,
    width: 31,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 183,
    r: 1.5,
    stroke: "#203864"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 187,
    width: 46,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 188,
    r: 1.5,
    stroke: "#203864"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 146,
    width: 142,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 150,
    width: 134,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 154,
    width: 52,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.543 147.334H22.8438C22.9401 147.334 23.0195 147.318 23.082 147.285C23.1445 147.251 23.1908 147.204 23.2207 147.145C23.252 147.083 23.2676 147.012 23.2676 146.932C23.2676 146.859 23.2533 146.794 23.2246 146.738C23.1973 146.681 23.1549 146.637 23.0977 146.605C23.0404 146.573 22.9681 146.557 22.8809 146.557C22.8118 146.557 22.748 146.57 22.6895 146.598C22.6309 146.625 22.584 146.663 22.5488 146.713C22.5137 146.762 22.4961 146.822 22.4961 146.893H21.9316C21.9316 146.736 21.9733 146.6 22.0566 146.484C22.1413 146.368 22.2546 146.278 22.3965 146.213C22.5384 146.148 22.6947 146.115 22.8652 146.115C23.0579 146.115 23.2266 146.146 23.3711 146.209C23.5156 146.27 23.6283 146.361 23.709 146.48C23.7897 146.6 23.8301 146.749 23.8301 146.926C23.8301 147.016 23.8092 147.103 23.7676 147.188C23.7259 147.271 23.666 147.346 23.5879 147.414C23.5111 147.48 23.4173 147.534 23.3066 147.574C23.196 147.613 23.0716 147.633 22.9336 147.633H22.543V147.334ZM22.543 147.762V147.471H22.9336C23.0885 147.471 23.2246 147.488 23.3418 147.523C23.459 147.559 23.5573 147.609 23.6367 147.676C23.7161 147.741 23.776 147.818 23.8164 147.908C23.8568 147.997 23.877 148.095 23.877 148.203C23.877 148.336 23.8516 148.454 23.8008 148.559C23.75 148.661 23.6784 148.749 23.5859 148.82C23.4948 148.892 23.388 148.947 23.2656 148.984C23.1432 149.021 23.0098 149.039 22.8652 149.039C22.7454 149.039 22.6276 149.023 22.5117 148.99C22.3971 148.956 22.293 148.906 22.1992 148.84C22.1068 148.772 22.0326 148.688 21.9766 148.586C21.9219 148.483 21.8945 148.361 21.8945 148.221H22.459C22.459 148.294 22.4772 148.359 22.5137 148.416C22.5501 148.473 22.6003 148.518 22.6641 148.551C22.7292 148.583 22.8014 148.6 22.8809 148.6C22.9707 148.6 23.0475 148.583 23.1113 148.551C23.1764 148.517 23.2259 148.47 23.2598 148.41C23.2949 148.349 23.3125 148.278 23.3125 148.197C23.3125 148.093 23.2936 148.01 23.2559 147.947C23.2181 147.883 23.1641 147.837 23.0938 147.807C23.0234 147.777 22.9401 147.762 22.8438 147.762H22.543ZM24.3145 148.729C24.3145 148.645 24.3431 148.576 24.4004 148.52C24.459 148.464 24.5365 148.436 24.6328 148.436C24.7292 148.436 24.806 148.464 24.8633 148.52C24.9219 148.576 24.9512 148.645 24.9512 148.729C24.9512 148.812 24.9219 148.882 24.8633 148.938C24.806 148.993 24.7292 149.021 24.6328 149.021C24.5365 149.021 24.459 148.993 24.4004 148.938C24.3431 148.882 24.3145 148.812 24.3145 148.729Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 113,
    width: 28,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 114,
    r: 1.5,
    stroke: "#203864"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 118,
    width: 41,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 119,
    r: 1.5,
    stroke: "#203864"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 123,
    width: 56,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 124,
    r: 1.5,
    stroke: "#203864"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 128,
    width: 54,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 129,
    r: 1.5,
    stroke: "#203864"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 133,
    width: 31,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 134,
    r: 1.5,
    stroke: "#203864"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 138,
    width: 46,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 139,
    r: 1.5,
    stroke: "#203864"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 103,
    width: 142,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 107,
    width: 30,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9121 105.561V106H21.9668V105.625L22.8867 104.639C22.9792 104.536 23.0521 104.445 23.1055 104.367C23.1589 104.288 23.1973 104.217 23.2207 104.154C23.2454 104.09 23.2578 104.03 23.2578 103.973C23.2578 103.887 23.2435 103.813 23.2148 103.752C23.1862 103.689 23.1439 103.641 23.0879 103.607C23.0332 103.574 22.9655 103.557 22.8848 103.557C22.7988 103.557 22.7246 103.577 22.6621 103.619C22.6009 103.661 22.554 103.719 22.5215 103.793C22.4902 103.867 22.4746 103.951 22.4746 104.045H21.9102C21.9102 103.876 21.9505 103.721 22.0312 103.58C22.112 103.438 22.2259 103.326 22.373 103.242C22.5202 103.158 22.6947 103.115 22.8965 103.115C23.0957 103.115 23.2637 103.148 23.4004 103.213C23.5384 103.277 23.6426 103.369 23.7129 103.49C23.7845 103.61 23.8203 103.753 23.8203 103.92C23.8203 104.014 23.8053 104.105 23.7754 104.195C23.7454 104.284 23.7025 104.372 23.6465 104.461C23.5918 104.548 23.5254 104.637 23.4473 104.727C23.3691 104.816 23.2826 104.91 23.1875 105.006L22.6934 105.561H23.9121ZM24.3145 105.729C24.3145 105.645 24.3431 105.576 24.4004 105.52C24.459 105.464 24.5365 105.436 24.6328 105.436C24.7292 105.436 24.806 105.464 24.8633 105.52C24.9219 105.576 24.9512 105.645 24.9512 105.729C24.9512 105.812 24.9219 105.882 24.8633 105.938C24.806 105.993 24.7292 106.021 24.6328 106.021C24.5365 106.021 24.459 105.993 24.4004 105.938C24.3431 105.882 24.3145 105.812 24.3145 105.729Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 205,
    width: 28,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 206,
    r: 1.5,
    stroke: "#203864"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 210,
    width: 41,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 211,
    r: 1.5,
    stroke: "#203864"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 215,
    width: 56,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 216,
    r: 1.5,
    stroke: "#203864"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 220,
    width: 54,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 221,
    r: 1.5,
    stroke: "#203864"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 225,
    width: 31,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 226,
    r: 1.5,
    stroke: "#203864"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 230,
    width: 46,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 231,
    r: 1.5,
    stroke: "#203864"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 195,
    width: 142,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 199,
    width: 110,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.959 196.938V197.379H21.9102L21.8828 197.037L23.0684 195.156H23.5156L23.0312 195.967L22.4414 196.938H23.959ZM23.6367 195.156V198H23.0742V195.156H23.6367ZM24.3145 197.729C24.3145 197.645 24.3431 197.576 24.4004 197.52C24.459 197.464 24.5365 197.436 24.6328 197.436C24.7292 197.436 24.806 197.464 24.8633 197.52C24.9219 197.576 24.9512 197.645 24.9512 197.729C24.9512 197.812 24.9219 197.882 24.8633 197.938C24.806 197.993 24.7292 198.021 24.6328 198.021C24.5365 198.021 24.459 197.993 24.4004 197.938C24.3431 197.882 24.3145 197.812 24.3145 197.729Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6750_16050",
    x: 0,
    y: 0,
    width: 195,
    height: 254,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6750_16050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6750_16050",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPesquisa);
export default __webpack_public_path__ + "static/media/Pesquisa.60f4e3d817bf49c1a5c4621a8d9fae1b.svg";
export { ForwardRef as ReactComponent };